import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CredentialsHelper = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const mockUsers = [
    {
      role: 'Organization Admin',
      email: 'admin@clearequal.com',
      password: 'Admin123!',
      description: 'Full system access, compliance management, reporting'
    },
    {
      role: 'Manager',
      email: 'manager@clearequal.com',
      password: 'Manager123!',
      description: 'Team insights, assessment participation, limited reporting'
    },
    {
      role: 'Employee',
      email: 'employee@clearequal.com',
      password: 'Employee123!',
      description: 'Personal pay information, peer comparisons, self-service'
    },
    {
      role: 'Auditor',
      email: 'auditor@clearequal.com',
      password: 'Auditor123!',
      description: 'Read-only access, compliance reports, audit logs'
    },
    {
      role: 'Approver',
      email: 'approver@clearequal.com',
      password: 'Approver123!',
      description: 'Reviews and ratifies sensitive changes (two-person rule)'
    }
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard?.writeText(text);
  };

  return (
    <div className="w-full max-w-md">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsExpanded(!isExpanded)}
        iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
        iconPosition="right"
        className="w-full justify-between text-muted-foreground hover:text-foreground"
      >
        Demo Credentials
      </Button>
      {isExpanded && (
        <div className="mt-4 p-4 bg-muted/50 rounded-lg border border-border">
          <div className="space-y-4">
            <div className="flex items-center space-x-2 mb-3">
              <Icon name="Info" size={14} className="text-primary" />
              <span className="text-xs font-medium text-foreground">
                Use these credentials to explore different user roles
              </span>
            </div>

            {mockUsers?.map((user, index) => (
              <div key={index} className="bg-card p-3 rounded-md border border-border">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-medium text-foreground">
                    {user?.role}
                  </span>
                  <div className="flex space-x-1">
                    <button
                      onClick={() => copyToClipboard(user?.email)}
                      className="p-1 hover:bg-muted rounded transition-smooth"
                      title="Copy email"
                    >
                      <Icon name="Copy" size={12} className="text-muted-foreground" />
                    </button>
                  </div>
                </div>
                
                <div className="space-y-1">
                  <div className="flex items-center space-x-2">
                    <Icon name="Mail" size={10} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground font-mono">
                      {user?.email}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Icon name="Key" size={10} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground font-mono">
                      {user?.password}
                    </span>
                  </div>
                </div>
                
                <p className="text-xs text-muted-foreground mt-2 italic">
                  {user?.description}
                </p>
              </div>
            ))}

            <div className="pt-2 border-t border-border">
              <p className="text-xs text-muted-foreground text-center">
                All demo data is anonymized and GDPR compliant
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CredentialsHelper;